import { React } from 'react'
import { icap, tr } from '../../../global-pure.js'
import PageLayout from '../../../containers/page/PageLayout'
import AskLink from '../../../components/AskLink'
import cardPic from '../../../assets/courses/investors.png'

export const card = {
  date: 'investors-course:date',
  title: 'investors-course:title',
  blurb: 'investors-course:blurb',
  subtitle: 'investors-course:subtitle',
  routeBuilder: () => `/${tr('courses')}/${tr('investors')}`,
  imgUrl: cardPic,
  call: 'course details'
}

const CoursePage = () => {
  return (
    <PageLayout>
      <div className='content'>
        <h1>{tr(card.title)}</h1>
        <h2>{tr(card.subtitle)}</h2>
        <p>{icap(tr('date'))+': '}{tr(card.date)}</p>
        <h4>{icap(tr('schedule'))+':'}</h4>
        <ul>
          <li><p>{tr('investors:option1')}</p></li>
        </ul>
        <h4>{icap(tr('this course is for'))+':'}</h4>
        <ul>
          <li><p>{icap(tr('high net worth individuals'))}</p></li>
          <li><p>{icap(tr('individuals with savings'))}</p></li>
          <li><p>{icap(tr('individuals with income to spare'))}</p></li>
        </ul>
        <h4>{icap(tr('this course includes'))+':'}</h4>
        <ul>
          <li><p>{tr('investors:bullet1')}</p></li>
          <li><p>{tr('investors:bullet2')}</p></li>
          <li><p>{tr('investors:bullet3')}</p></li>
          <li><p>{tr('investors:bullet4')}</p></li>
        </ul>
        <h4>{icap(tr('prerequisites'))+':'}</h4>
        <p>{icap(tr('none'))}</p>
        <h4>{icap(tr('payment methods'))+':'}</h4>
        <ul>
          <li><p>{icap(tr('Guarani cash'))}</p></li>
          <li><p>{icap(tr('Guarani, bank deposit'))}</p></li>
          <li><p>{icap(tr('Dollars, PayPal'))}</p></li>
          <li><p>{icap(tr('Dollars, bank deposit'))}</p></li>
        </ul>
        <h4>{icap(tr('registration'))+':'}</h4>
        <p>{icap(tr('online, effective upon receipt of payment'))}</p>
        <p>{icap(tr('Questions?'))}{' '}<AskLink /></p>
      </div>
    </PageLayout>
  )
}

export default CoursePage